<template>
  <div>
    <div v-for="f in staticFilter" :key="f.key">
      <label>{{ f.title }}</label>
      <radio-list
        :name="`${f.key}-filter`"
        v-model="params[f.key]"
        :items="f.items"
        @input="filterSet"
      />
    </div>
    <hr />
    <h5>Фильтры</h5>
    <div class="row">
      <div v-for="filter in filters" :key="filter.key" class="col-6 col-md-4">
        <filter-item
          :modal="filter.key"
          :title="filter.title"
          :titleKey="filter.titleKey"
          v-model="params[`${filter.key}_id`]"
          @input="filterSet"
        />
      </div>
    </div>
    <list
      v-if="restart === false"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :manipulation="manipulation"
      :itemLink="itemLink"
      :setLink="setLink"
      :manipulateLink="manipulateLink"
      :params="params"
      :setImport="true"
      :fields="fields"
      :searchDisable="false"
      :simple="false"
      :exportFields="exportFields"
      v-model="val"
      @changeFunction="changeFunction"
    />
  </div>
</template>
<script>
// import { mapState, mapMutations } from "vuex";

export default {
  name: "groups",
  components: {
    list: () => import("../List"),
    FilterItem: () => import("../Filter"),
    RadioList: () => import("../Filters/RadioList"),
  },
  methods: {
    filterSet(val) {
      this.params["page"] = 1;
      // this.restart = true;
      // this.params["page"] = 1;
      // setTimeout(() => {

      //   this.params["updatedAt"] = Date.now();
      //   // this.restart = false;
      // }, 10);
    },
    changeFunction(val) {},
  },
  data() {
    return {
      exportFields: {
        ID: "display_name",
        AMO_ID: "amo_id",
        BILLZ_ID: "_ID",
        title: "display_name",
        description: "annotation",

        SKU: "sku",
        image: "image_original",
        price: "price",
        quantity: "quantity",
        created_at: "created_at",
      },
      manipulation: [
        {
          title: "Активировать",
          key: "is_active",
          value: 1,
        },
        {
          title: "Деактивировать",
          key: "is_active",
          value: 0,
        },
      ],
      /**START ADD ITEM */
      filters: [
        {
          key: "brands",
          title: "Бренды",
        },
        {
          key: "categories",
          title: "Категории",
        },
        {
          key: "label",
          title: "Теги",
        },
        {
          key: "name",
          title: "Классы",
        },
        {
          key: "group",
          title: "Группы",
        },
        {
          key: "business",
          title: "Бизнес",
          titleKey: "name",
        },
      ],
      staticFilter: [
        {
          title: "Наличие на складе",
          key: "stock",
          default: "1",
          items: [
            {
              id: 1,
              title: "Все",
            },
            {
              id: 2,
              title: "Нет на складе",
            },
            {
              id: 3,
              title: "Есть на складе",
            },
          ],
        },
        {
          title: "Активность товара",
          key: "active",
          default: "1",
          items: [
            {
              id: 1,
              title: "Все",
            },
            {
              id: 2,
              title: "Неактивный",
            },
            {
              id: 3,
              title: "Активный",
            },
          ],
        },
        {
          title: "Наличие фото у товара",
          key: "image",
          default: "1",
          items: [
            {
              id: 0,
              title: "Все",
            },
            {
              id: 1,
              title: "С фото",
            },
            {
              id: 2,
              title: "Без фото",
            },
          ],
        },
      ],
      restart: false,
      val: [],
      params: {
        stock: 1,
        active: 1,
        product: 0,
      },
      modalCreate: "product",
      fields: [
        {
          key: "product",
          label: "Группа товаров",
          type: "object",
          subFields: [
            {
              label: "Бренд",
              key: "brand",
              type: "select",
              selectKey: "title",
              modal: "brands",
            },
            {
              label: "Класс товара",
              key: "name",
              type: "select",
              selectKey: "title",
              modal: "name",
            },
            {
              key: "category",
              selectKey: "full_title",
              label: "Категория-(и)",
              type: "selects",
              modal: "categories",
            },
          ],
        },
        {
          key: "name",
          label: "Название модели (уникальность)",
          type: "field",
          textType: "text",
        },
        {
          key: "title",
          label: "Доп. название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          label: "Цвет",
          key: "color",
          type: "select",
          selectKey: "title",
          modal: "color",
        },

        {
          key: "sku",
          label: "Баркод",
          type: "field",
          textType: "text",
        },
        {
          key: "price",
          label: "Цена",
          type: "field",
          textType: "number",
        },
        {
          key: "quantity",
          label: "Количество",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "products/delete",
      manipulateLink: "products/manipulate",
      cardLink: "page",
      itemLink: "products/list",
      setLink: "products/add",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "image",
          title: "",
          checkbox: false,
          image: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "sku",
          title: "Баркод",
          control: false,
          full: true,
          align: "left",
          checkbox: false,
          sortBy: "sku",
        },
        {
          key: "business",
          title: "Бизнес",
          control: false,
          full: true,
          object: "name",
          align: "left",
          checkbox: false,
        },
        {
          key: "display_name",
          title: "Название",
          full: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "Активный",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "price",
          title: "Цена",
          checkbox: false,
          control: false,
          sortBy: "price",
        },
        {
          key: "price_main",
          title: "Главная цена",
          checkbox: false,
          control: false,
          sortBy: "price_main",
        },
        {
          key: "quantity",
          title: "Кол-во (шт.)",
          checkbox: false,
          control: false,
          sortBy: "quantity",
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
          control: false,
          sortBy: "created_at",
        },
        {
          key: "updated_at",
          title: "Обновлен",
          dateTimeFormat: true,
          control: false,
          sortBy: "updated_at",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
